import { ALLOW_SUBSCRIPTIONS } from 'shared/constants/common';
import { IntroductionSection } from './sections/IntroductionSection';
import { NewsletterCommunitySection } from './sections/NewsletterCommunitySection';
import { HeroSlideshow } from './sections/HeroSlideshow';
import { ListenEverywhere } from './sections/ListenEverywhere';
import { hasPublishedEpisodes } from 'shared/utils/getEpisode';

export default function Home() {
  const showListenLinks = hasPublishedEpisodes()
  return (
    <>
      <HeroSlideshow />
      <IntroductionSection />
      {showListenLinks ?<ListenEverywhere /> : null}
      { ALLOW_SUBSCRIPTIONS ? <NewsletterCommunitySection /> : null }
    </>
  );
}
